/* eslint-disable no-param-reassign */
import * as logger from 'loglevel';
import { getHistograms } from '../../../_integrations/everymundo/rates';
import { histogramsToFlatFares } from '../../../_integrations/everymundo/utils/normalizeFareLikeData';
import { isSSR } from '@front10/utils';
import { withCommonPreloads } from './commons/commonRatesPreloads';

const preloadCustomPropsExecute = (cmpConfig, clientPromises, ssrPromises) => {
  return new Promise((resolve, reject) => {
    const {
      containerConfig: {
        settings: {
          integrationSettings,
          prePopulation,
          // visibleItemsAmount = 3,
          // prePopulation: { originCity, destinationCity },
          meta,
          pageContext
        }
      },
      name,
      simulateSSR
    } = cmpConfig;

    const filters = Object.assign({}, prePopulation, {
      // origin: originCity,
      // destination: destinationCity,
      // dateRange: {
      //   start: dayjs().toDate(),
      //   end: dayjs().add(visibleItemsAmount, 'month').endOf('month').toDate()
      // }
    });

    let promises = [];
    if (!isSSR(simulateSSR)) {
      promises = clientPromises;
    } else {
      ssrPromises.push(getHistograms(filters, integrationSettings, meta, pageContext));
      promises = ssrPromises;
    }

    Promise.all(promises)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(([others, histograms]) => {
        cmpConfig.containerConfig.settings.getHistograms = getHistograms;
        cmpConfig.containerConfig.settings.initialHistograms = histograms;
        // Fares Schema Implementation -> https://everymundo.atlassian.net/browse/FC-1700
        cmpConfig.containerConfig.settings.normalizedFlatFaresForSchema = histogramsToFlatFares(
          histograms
        );
        resolve(cmpConfig);
      })
      .catch((err) => {
        logger.error(`PRELOAD_CUSTOM_PROPS: ${name}`, err);
        reject(err);
      });
  });
};

const preloadCustomProps = (cmpConfig) => {
  // HOC For all Common Preload Logic
  return withCommonPreloads(preloadCustomPropsExecute, cmpConfig);
};

export default preloadCustomProps;
